import calendarService from '@/services/calendar/calendar.service';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { Box } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import { Temporal } from 'temporal-polyfill';
import Day from './components/day/day.view';

interface IProps {
	visibleDays: number;
	events: Array<ICalendarEvent>;
	fromInstant: DateTime;
	onEventClick: (event: ICalendarEvent) => void;
}

export default function EventList(props: IProps) {
	return (
		<Box display="grid" gridTemplateRows="1fr" h="full">
			<Box
				display="grid"
				gridTemplateColumns={`repeat(${props.visibleDays}, 1fr)`}
				gap={0}
				h="full"
				w="full"
				overflow="auto"
			>
				{Array.from({ length: props.visibleDays }, (_, i) => i + 1).map((diff) => {
					const day = DateTime.fromISO(props.fromInstant.toISO()!, { zone: props.fromInstant.zoneName! })
						.plus({ days: diff })
						.startOf('day');

					const heading = calendarService.formatDate({
						date: day.toJSDate(),
						locale: 'es',
						options: { month: 'long', day: '2-digit' },
					});

					const filteredEvents = props.events.filter((e) => {
						const dayTemporal = Temporal.ZonedDateTime.from(
							`${day.toJSDate().toISOString()}[${props.fromInstant.zoneName}]`
						).toPlainDate();

						const start = Temporal.ZonedDateTime.from(
							`${e.interval?.inclusiveStart.dateTime}[${e.interval?.inclusiveStart.timeZone}]`
						).toPlainDate();

						return dayTemporal.equals(start);
					});
					return (
						<Day
							dateTime={day}
							key={diff}
							events={filteredEvents}
							onEventClick={props.onEventClick}
							heading={heading}
						/>
					);
				})}
			</Box>
		</Box>
	);
}
